export default "__VITE_ASSET__DI_4tZ$Z__"